<script>
import { get } from 'vuex-pathify'

export default {
	data() {
		return {
			show: false,
			loading: false,
			customData: {},
			validation: {},
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.user && this.hasRequiredFields) {
				this.setup()
				this.showIfMissingRequiredFields()
			}
		})
	},
	watch: {
		user(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.setup()
				this.showIfMissingFields()
			}
		},
		'$route.name'(newVal, oldVal) {
			if (newVal.includes('checkout')) {
				this.showIfMissingRequiredFields()
			}
		},
	},
	computed: {
		data() {
			return this.$srv('userCustomFields')
		},
		fields() {
			return this.$srv('userCustomFields.fields', [])
		},
		hasRequiredFields() {
			return this.fields.some((f) => f.isRequired)
		},
		user: get('shop/user'),
		routeIsCheckout() {
			return !!this.$route.name?.includes('checkout')
		},
	},
	methods: {
		setup() {
			const fields = this.fields.reduce((obj, f) => {
				obj[f.key] = this.user.customData?.[f.key] || ''
				return obj
			}, {})
			this.customData = fields
		},
		showIfMissingFields() {
			const hasMissingFields = this.fields.some((f) => !this.user?.customData?.[f.key])
			if (hasMissingFields) this.show = true
		},
		showIfMissingRequiredFields() {
			const hasMissingFields = this.fields.some((f) => f.isRequired && !this.user?.customData?.[f.key])
			if (hasMissingFields) this.show = true
		},
		getFieldIs(field) {
			if (field.type == 'select') return 'Select'
			return 'TextField'
		},
		getFieldBind(field) {
			const bindMap = {
				select: { items: field.options?.map((o) => o.item) },
				number: { type: 'number' },
				date: { type: 'date' },
			}
			return bindMap[field.type] || {}
		},
		save() {
			const data = {}
			this.fields.forEach((f) => {
				if (this.fields[f.key] !== undefined) {
					data[f.key] = this.fields[f.key]
				}
			})
			this.$shopApi.put({
				url: '/user/user-update',
				loading: (v) => (this.loading = v),
				data: { customData: this.customData },
				onValidation: ({ validation }) => {
					this.validation = validation
				},
				onSuccess: () => {
					this.show = false
					this.$emit('saved')
				},
			})
		},
	},
}
</script>

<template>
	<v-dialog
		v-if="data && user"
		v-model="show"
		max-width="480px"
		:persistent="routeIsCheckout && hasRequiredFields"
		scrollable
	>
		<v-card>
			<v-card-title v-if="data.title">
				<div class="w100">
					{{ data.title }}
					<v-divider class="my-2 mb-4" />
				</div>
			</v-card-title>
			<v-card-subtitle>
				Esta información puede ser actualizada desde
				<SafeLink :to="{ name: 'user.account' }" class="font-weight-bold nowrap">
					<span @click="show = false">Mi Cuenta</span>
				</SafeLink>
			</v-card-subtitle>
			<v-card-text>
				<Validator :validation="validation">
					<div class="d-flex flex-column" style="gap: 12px">
						<component
							:validator-key="'user.customData.' + field.key"
							v-for="field in $srv('userCustomFields.fields', [])"
							:key="field.key"
							:disabled="user && user.fixedIdentityFields && field.fixFieldAfterBuy"
							outlined
							:label="field.label"
							:is="getFieldIs(field)"
							v-bind="getFieldBind(field)"
							v-model="customData[field.key]"
						/>
					</div>
				</Validator>
			</v-card-text>
			<v-card-actions class="justify-end">
				<Button
					class="flex-shrink-0 mr-2"
					v-if="!routeIsCheckout || !hasRequiredFields"
					text
					@click="show = false"
					>Cerrar</Button
				>
				<Button @click="save" color="success" large class="px-md-8"> Guardar </Button>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

